import API from "../../../services/API"
import { useQuery } from "react-query"
import { useParams } from "react-router-dom";

export default function useDpcItems(){

    const { id: courseId } = useParams();

    return useQuery({

        queryKey: ['dpc_items'],

        queryFn: async () => {
            const { data: dpcItems } = await API.get('/dpc/double');
            const courseDpcItems = dpcItems.filter((i) => i.course === courseId);
            return courseDpcItems.length > 0 ? courseDpcItems : dpcItems;
        },
    })
}